import styled from "styled-components";

import color from "../../constants/color";

export const Container = styled.div`
  margin-top: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 56px);
`;

export const Content = styled.div`
  width: 983px;
  border-radius: 8px;
  background: ${color.White};
`;

export const HeaderContent = styled.div`
  border-radius: 8px 8px 0px 0px;
  background: ${color.Success};
  padding: 30px;
`;

export const HeaderTitle = styled.h1`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.White};
  width: 100%;
  text-align: center;
`;

export const BoxImgSuccess = styled.div`
  width: 33.94px;
  margin: 0 auto;
  margin-bottom: 10px;
  svg {
    width: 100%;
  }
`;

export const InfoContent = styled.div`
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TitleInfo = styled.h2`
  font-family: Inter;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #333333;
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
  font-weight: 400;
`;
export const BoxImgArt = styled.div`
  width: 216.08px;
  margin-bottom: 40px;
  img {
    width: 100%;
  }
`;

export const LinkReturn = styled.a`
  width: 100%;
  background: ${color.Primary50};
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  text-decoration: none;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  color: #2d5bff;
  transition: all 0.3s;

  &:hover {
    background: rgba(45, 91, 255, 0.2);
  }
`;
